module.exports = __webpack_public_path__ + "img/woman.dcd12930.png";